<mat-card>{{'projects.mystuff' | translate}}</mat-card>
<mat-card style="margin: 30px" *ngIf="loaded && projects.length == 0">
    {{'projects.noproject' | translate}}
</mat-card>
<!-- <mat-grid-list *ngIf="loaded &&  projects.length != 0" cols="2" rowHeight="2:1">
    <mat-grid-tile *ngFor="let project of projects"> -->
 <div fxLayout="row wrap" fxLayoutGap="32px" fxLayoutAlign="flex-start">
    <mat-card *ngFor="let project of projects" class="card-project">
        <mat-card-title>{{project.name}} ({{ project.type}})</mat-card-title>
        <mat-card-content>
            <p>{{project.description}}</p>
            <h4>{{'projects.classes' | translate}}</h4>
            <mat-chip-list>
                <mat-chip color="primary" *ngFor="let clase of project.classes"> {{clase}}</mat-chip>
            </mat-chip-list>
            <p *ngIf="project.shared">{{'projects.shared' | translate}}</p>
        </mat-card-content>
        <mat-card-actions>
            <button mat-raised-button matTooltip="{{'projects.load' | translate}}" (click)="loadProject(project)" mat-button>
                <mat-icon>input</mat-icon>
            </button>
            <button mat-raised-button matTooltip="{{'projects.edit' | translate}}" (click)="showProjectForm(project)" mat-button>
                <mat-icon>edit</mat-icon>
            </button>
            <button *ngIf="!project.shared" mat-raised-button matTooltip="{{'projects.share' | translate}}" (click)="shareProject(project)"
                mat-button>
                <mat-icon>share</mat-icon>
            </button>
            <button *ngIf="project.shared" mat-raised-button matTooltip="{{'projects.notshare' | translate}}" (click)="unShareProject(project)"
                mat-button>
                <mat-icon>undo</mat-icon>
            </button>
            <button mat-raised-button matTooltip="{{'projects.delete' | translate}}" (click)="deleteProject(project.id)" mat-button>
                <mat-icon>delete</mat-icon>
            </button>
        </mat-card-actions>
    </mat-card>

</div>
